import { Page, PageHeader } from '@/components';
import { BuildingRecordGrid } from '@/pages/Tools/BuildingInspection/components/BuildingRecordGrid';

const BuildingRecord = () => {
  return (
    <Page>
      <PageHeader title="Building Inspections Management" backRoute="/tools" />
      <BuildingRecordGrid />
    </Page>
  );
};

export default BuildingRecord;
